// ABOUTME: The breathing round's progress: the fraction of the round that has passed.
// ABOUTME: It is 1 (the storm row) when no round is armed; the sky strip's position follows it.

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

export function roundProgress(armed: boolean, total: number, leftSec: number): number {
  return armed && total > 0 ? clamp01(1 - leftSec / total) : 1;
}
